// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipient-img {
	width: 52px;
	height: 52px;
	border-radius: 50%;
	object-fit: cover;
	background-color: rgba(128, 128, 128, 0.153);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/RecipientsDetails/recipient.m.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,4CAA4C;AAC7C","sourcesContent":[".recipient-img {\n\twidth: 52px;\n\theight: 52px;\n\tborder-radius: 50%;\n\tobject-fit: cover;\n\tbackground-color: rgba(128, 128, 128, 0.153);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
